import { render, staticRenderFns } from "./APIKeyItem.vue?vue&type=template&id=5af24866"
import script from "./APIKeyItem.vue?vue&type=script&setup=true&lang=js"
export * from "./APIKeyItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports